import React, {useCallback} from "react";
import {FLOOR_TYPES} from "../../constants/floorTypes";
import {getAvailableFloorTypes} from "./utils/FloorTypeUtils";

export const FloorForm = ({
  floors,
  initialFloor,
  currentFloor,
  index,
  onChange,
  onAddFloor,
  onRemoveFloor,
}) => {
  const availableTypes = getAvailableFloorTypes(floors, index);

  const updateFloorType = useCallback((e) => {
    const floorType = e.target.value;
    const updated = {
      ...currentFloor,
      floorType: floorType,
      display_name: FLOOR_TYPES[floorType || FLOOR_TYPES.UNKNOWN.value]?.label
    };
    onChange(updated, index);
  }, [currentFloor, onChange, index]);

  const updateFloorUnits = useCallback((unitType, count) => {
    let initialUnitsCount = initialFloor !== undefined
        ? initialFloor?.units[unitType] : 0;
    let updatedValue = initialUnitsCount;
    if (count !== '' && count !== null && count !== undefined) {
      updatedValue = Math.max(initialUnitsCount,
          parseInt(count) || initialUnitsCount);
    }
    const updated = {
      ...currentFloor,
      units: {
        ...currentFloor.units,
        [unitType]: updatedValue
      }
    }
    onChange(updated, index);
  }, [currentFloor, initialFloor, onChange, index]);

  if (!currentFloor) {
    return null;
  }

  return (
      <div key={index} className="border rounded-lg bg-gray-50">
        <div
            className="flex items-center justify-between p-3 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <span
                className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-800 text-sm font-medium">{index
                + 1}</span>
            <div className="flex-grow flex items-center space-x-3">
              <select
                  key={index}
                  value={currentFloor?.floorType}
                  onChange={updateFloorType}
                  className="form-select text-sm"
              >
                {Object.entries(availableTypes).map(([key, entry]) => (
                    <option key={key}
                            value={entry.value}>{entry.label}</option>))}
              </select>
              {index === floors.length - 1 && (
                  <span
                      onClick={onAddFloor}
                      className="text-sm font-medium cursor-pointer hover:underline"
                      style={{color: '#C5703D'}}
                      title="Neue Etage hinzufügen"
                  >+ Etage hinzufügen
                  </span>
              )}
            </div>
          </div>
          {floors.length > 1 && (
              <div className="flex-shrink-0">
                <button key={index} type="button"
                        onClick={() => onRemoveFloor(index)}
                        className="inline-flex items-center p-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                        title="Etage entfernen">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor"
                       viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </div>
          )}
        </div>

        <div className="p-3" style={{backgroundColor: '#F6F6F6'}}>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label
                  className="block text-sm font-medium text-gray-700 mb-1">Wohneinheiten</label>
              <input type="number" min="0"
                     value={currentFloor?.units?.livingUnitCount || 0}
                     onChange={e => updateFloorUnits('livingUnitCount',
                         e.target.value === '' ? 0 : e.target.value)}
                     onFocus={e => {
                       if (e.target.value === '0') {
                         e.target.select();
                       }
                     }}
                     className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                     placeholder="0"/>
            </div>
            <div>
              <label
                  className="block text-sm font-medium text-gray-700 mb-1">Gewerbeeinheiten</label>
              <input type="number" min="0"
                     value={currentFloor?.units?.commercialUnitCount || 0}
                     onChange={e => updateFloorUnits('commercialUnitCount',
                         e.target.value === '' ? 0 : e.target.value)}
                     onFocus={e => {
                       if (e.target.value === '0') {
                         e.target.select();
                       }
                     }}
                     className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                     placeholder="0"/>
            </div>
          </div>
          {(currentFloor?.units?.livingUnitCount > 0
              || currentFloor?.units?.commercialUnitCount > 0) && (
              <div className="mt-2 text-xs text-gray-700">
                <strong>Etage {index + 1} Gesamt:</strong>
                {currentFloor?.units?.livingUnitCount > 0 && (
                    <span> {currentFloor?.units?.livingUnitCount} WE</span>)}
                {currentFloor?.units?.commercialUnitCount > 0 && (
                    <span>{currentFloor?.units?.livingUnitCount > 0 ? ', '
                        : ' '}{currentFloor?.units?.commercialUnitCount} GE</span>)}
              </div>
          )}
        </div>
      </div>
  );
}